/** A task sentence that talks about money. The words are not a ledger entry. */
const MONEY_CLAIM = /(?:оплатил[аи]?|оплатили|перев[её]л[аи]?|перевели|перевод|оплачено)/i;

export interface TaskMoneyContext {
  provesPayment: false;
  review: 'факт или задача';
  source: 'текст задачи';
  createdAt: string | null;
  ledgerWrite: false;
  autoClose: false;
}

export function taskMoneyContext(task: {
  title: string;
  description?: string | null;
  created_at?: string | null;
}): TaskMoneyContext | null {
  const text = `${task.title}\n${task.description ?? ''}`;
  if (!MONEY_CLAIM.test(text)) return null;
  return {
    provesPayment: false,
    review: 'факт или задача',
    source: 'текст задачи',
    createdAt: task.created_at ?? null,
    ledgerWrite: false,
    autoClose: false,
  };
}
